// // import React, { useState } from "react";
// // import Login from "./components/Login";
// // import DataTable from "./components/DataTable";
// // import Charts from "./components/Charts";  // ✅ 确保引入 Charts 组件
// //
// // function App() {
// //     const [authenticated, setAuthenticated] = useState(false);
// //
// //     return (
// //         <div>
// //             {authenticated ? (
// //                 <div>
// //                     <DataTable />  {/* ✅ 数据表格 */}
// //                     <Charts />      {/* ✅ 图表 */}
// //                 </div>
// //             ) : (
// //                 <Login setAuthenticated={setAuthenticated} />
// //             )}
// //         </div>
// //     );
// // }
// //
// // export default App;
// //
// import React, { useState } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Login from "./components/Login";
// import DataTable from "./components/DataTable";
// import Charts from "./components/Charts";
// import MaterialDetailPage from "./components/materials/MaterialDetailPage";
// import Signup from "./components/Signup";  // ✅ 详情页
//
// function App() {
//     const [authenticated, setAuthenticated] = useState(false);
//
//     return (
//         <Router> {/* ✅ 确保 Router 包裹整个应用 */}
//             {authenticated ? (
//                 <Routes>
//                     {/* 主页：数据表格 + 图表 */}
//                     <Route path="/" element={
//                         <div>
//                             <DataTable />
//                             <Charts />
//                         </div>
//                     } />
//
//                     {/* 材料详情页 */}
//                     <Route path="/materials/:materialId" element={<MaterialDetailPage />} />
//                 </Routes>
//             ) : (
//         <Routes>
//           {/* 如果未认证，设置登录和注册路由 */}
//           <Route path="/login" element={<Login setAuthenticated={setAuthenticated} />} />
//           <Route path="/signup" element={<Signup setAuthenticated={setAuthenticated} />} />
//           {/* 默认重定向到登录页面 */}
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         </Routes>
//             )}
//         </Router>
//     );
// }
//
// export default App;
//
// export default App;
// import React, { useState } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Login from "./components/Login";
// import Signup from "./components/Signup";
// import DataTable from "./components/DataTable";
// import Charts from "./components/Charts";
// import MaterialDetailPage from "./components/materials/MaterialDetailPage";

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Signup from "./components/Signup";
import DataTable from "./components/DataTable";
import Charts from "./components/Charts";
import MaterialDetailPage from "./components/materials/MaterialDetailPage";
import { Link } from "react-router-dom";
import PredictCif from "./components/model_pred";
import predictGif from "./components/assets/GIF-pred.gif";
import ThermoAssistant from "./components/ThermoAssistant"; // 你可以改路径
import VerifyEmail from "./components/VerifyEmail";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";


function App() {
  const [authenticated, setAuthenticated] = useState(() => {
    return sessionStorage.getItem("authenticated") === "true";
  });

  useEffect(() => {
    sessionStorage.setItem("authenticated", authenticated);
  }, [authenticated]);

  return (
    <Router>
      <Routes>
        {authenticated ? (
          /* ==========================================
             🔒 已登录：内部核心业务区块
             ========================================== */
          <>
            <Route
              path="/"
              element={
                <div>
                  <DataTable />
                  <Charts />
                  <div className="mt-4">
                </div>
                </div>
              }
            />
            <Route path="/assistant" element={<ThermoAssistant />} />
            <Route path="/predict" element={<PredictCif />} />
            <Route path="/materials/:materialId" element={<MaterialDetailPage />} />
            {/* 任何未知的内部路径都跳转回首页 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          /* ==========================================
             🌐 未登录：公共账号管理区块
             ========================================== */
          <>
            <Route path="/login" element={<Login setAuthenticated={setAuthenticated} />} />
            <Route path="/signup" element={<Signup setAuthenticated={setAuthenticated} />} />

            {/* 🌟 将三个新页面放置于此，允许外部游客直接访问 */}
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* 任何未知的外部路径都跳转回登录页 */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
